import { render } from "./PrincipalOutClientComponent.vue?vue&type=template&id=1e4524ba&scoped=true"
import script from "./PrincipalOutClientComponent.vue?vue&type=script&lang=js"
export * from "./PrincipalOutClientComponent.vue?vue&type=script&lang=js"

import "./PrincipalOutClientComponent.vue?vue&type=style&index=0&id=1e4524ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4524ba"]])

export default __exports__